
export function Button({ children, className = "", ...props }) {
  return (
    <button
      className={`px-6 py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-xl shadow ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
